
interface ValidationErrors {
    [key: string]: string[];
}

export function useFormErrors() {
  const serverErrors = ref<ValidationErrors>({});

  const handleServerErrors = (error: unknown) => {
    serverErrors.value = {}; // Clear previous errors

    const gqlError = error as { graphQLErrors?: Array<{ extensions?: { validation?: Record<string, string | string[]> } }> };
    if (gqlError.graphQLErrors && gqlError.graphQLErrors.length > 0) {
      for (const graphQLError of gqlError.graphQLErrors) {
        if (graphQLError.extensions && graphQLError.extensions.validation) {
          const validationErrors = graphQLError.extensions.validation;
          for (const key in validationErrors) {
            if (Object.prototype.hasOwnProperty.call(validationErrors, key)) {
              // Ensure we have an array of strings
              const messages = Array.isArray(validationErrors[key])
                ? validationErrors[key]
                : [validationErrors[key]];
              serverErrors.value[key] = messages;
            }
          }
        }
      }
    }
  };

  const clearErrors = () => {
    serverErrors.value = {};
  };

  /**
   * First validation message across all fields — for toast-based flows that
   * have no per-field inputs to attach messages to.
   */
  const getFirstErrorMessage = (): string => {
    const first = Object.values(serverErrors.value)[0];
    return first?.[0] ?? '';
  };

  const getErrorMessage = (field: string): string => {
    // 1. Try direct match
    const directErrors = serverErrors.value[field];
    if (directErrors && directErrors.length > 0) {
      return directErrors[0] || '';
    }

    // 2. Try simple fuzzy match for nested keys (e.g. "input.data.field" matches "field")
    const key = Object.keys(serverErrors.value).find(k => k.endsWith(`.${field}`));
    if (key) {
      const nestedErrors = serverErrors.value[key];
      if (nestedErrors && nestedErrors.length > 0) {
        return nestedErrors[0] || '';
      }
    }

    return '';
  };

  return {
    serverErrors,
    handleServerErrors,
    clearErrors,
    getErrorMessage,
    getFirstErrorMessage,
  };
}
